<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage petty cashes</small>
      </legend>
      <div></div>
      <div class="pettycashesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color:blue"></i> loading pettycashes...
      </div>

      <vue-good-table
        :columns="columns"
        :rows="systemPettycashes"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'account_id'">
           <span v-if="props.row.account_id === 1">
                <button class="btn btn-primary btn-sm btn-flat">
                  <i class="fa fa-money"></i> CASH
                </button>
              </span>
              <span v-else-if="props.row.account_id === 2">
                <button class="btn btn-success btn-sm">
                  <i class="fa fa fa-mobile"></i> MPESA
                </button>
              </span>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account name",
          field: "account_id",
          type: "text"
        },
        {
          label: "Disbursed amount",
          field: "disbursed_amount",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by petty cash amount"
          }
        },
        {
          label: "Balance amount",
          field: "balance_amount",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by balance amount"
          }
        }
      ]
    };
  },
  created() {
    this.loadPettycash();
  },
  computed: {
    ...mapGetters(["systemPettycashes"])
  },
  methods: {
    ...mapActions(["loadPettycash"])
  }
};
</script>


// WEBPACK FOOTER //
// src/pettycashes/managepettycashes.vue